<template>
  <div class="home">
    <h1 class="text-center">Velkommen til Kennel Hillsbrook</h1>

    <div class="text-center mt-4">
      <p>Vi har 2 søde drenge der søger nyt hjem.</p>
      <p>Vi håber i finder de oplysninger I skal bruge - ellers er I meget velkommen til at kontakte os.</p>
      <p>Hjemmesiden er pt. under ombygning - så kontakt os hvis du mangler informationer.</p>
      <p>God fornøjelse...</p>
    </div>

    <div class="lightboxWrapper d-flex flex-wrap justify-center">
      <img
        v-for="(image, index) in media"
        :key="index"
        v-lazy="image.src || image.thumb"
        @click="openGallery(index)"
      />

      <LightBox ref="lightbox" :media="media" :show-light-box="false" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LightBox from 'vue-image-lightbox';

export default {
  name: 'Home',
  components: {
    LightBox
  },
  data: () => ({
    // publicPath: process.env.BASE_URL, // skal brugees hvis jeg vil referere til en img URL fra template, men pt. refererer jeg kun til img's her fra data prop'en
    media: [
      {
        thumb: `${process.env.BASE_URL}images/kuld1.png`,
        src: `${process.env.BASE_URL}images/kuld1.png`,
        caption: 'Billede 2' // Optional
      },
      {
        thumb: `${process.env.BASE_URL}images/DSC_0004.png`,
        src: `${process.env.BASE_URL}images/DSC_0004.png`,
        caption: 'Billede 2' // Optional
      },
      {
        thumb: `${process.env.BASE_URL}images/Joodii - forside.png`,
        src: `${process.env.BASE_URL}images/Joodii - forside.png`,
        caption: 'Billede 3' // Optional
      },
      {
        thumb: `${process.env.BASE_URL}images/DSC_0054.png`,
        src: `${process.env.BASE_URL}images/DSC_0054.png`,
        caption: 'Billede 4' // Optional
      },
      {
        thumb: `${process.env.BASE_URL}images/DSC_0053.png`,
        src: `${process.env.BASE_URL}images/DSC_0053.png`,
        caption: 'Billede 5' // Optional
      },
      {
        thumb: `${process.env.BASE_URL}images/DSC_0067 - hovedbillede Eddie.png`,
        src: `${process.env.BASE_URL}images/DSC_0067 - hovedbillede Eddie.png`,
        caption: 'Billede 6' // Optional
      },
      {
        thumb: `${process.env.BASE_URL}images/DSC_0158.png`,
        src: `${process.env.BASE_URL}images/DSC_0158.png`,
        caption: 'Billede6' // Optional
      }
    ]
  }),
  computed: {
    ...mapState(['test', 'dogs']),
    largeMedia: function () {
      return this.media.find((x) => x.large == true);
    },
    smallMedia: function () {
      return this.media.filter((x) => x.large !== true);
    },
    getSortedMedia: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sorted = this.media.sort((x) => x.large == true);
      return sorted;
    }
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  }
};
</script>

<style lang="less">
.lightboxWrapper {
  // Hide img count
  .vue-lb-footer-count {
    display: none;
  }

  > img {
    flex: 0 1 auto;
    object-fit: cover;
    height: 150px;
    width: 209px;

    margin: 0 5px 20px 5px;
    cursor: pointer;

    &:first-child {
      flex: 0 0 100%;
      height: 500px;
    }
  }
}
</style>